export default {
    preferences: {},
    addContactsJobVersion: '',
};
